import React, { ComponentPropsWithoutRef, ElementRef, forwardRef } from "react";
import {
	Collapsible,
	CollapsibleContent as CollapsibleContentPrimitive,
} from "@radix-ui/react-collapsible";

import { cn } from "@/lib/utils";

export { Collapsible };

export const CollapsibleContent = forwardRef<
	ElementRef<typeof CollapsibleContentPrimitive>,
	ComponentPropsWithoutRef<typeof CollapsibleContentPrimitive>
>(({ className, children, ...props }, ref) => (
	<CollapsibleContentPrimitive
		ref={ref}
		className={cn(
			"data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down",
			className,
		)}
		{...props}
	>
		{children}
	</CollapsibleContentPrimitive>
));

CollapsibleContent.displayName = CollapsibleContentPrimitive.displayName;
